import React, { Fragment } from 'react';

import { Input, Label, FormGroup } from 'twyne-new.ui'
import { Tag } from 'lucide-react';

import BaseItem from './Base';
import { TYPE_LIST, TYPE_OBJECT, TYPE_PROPERTY } from './types';
import NewKeyValue from '../NewKeyValue'

export default class PropertyItem extends BaseItem {
  accept = [TYPE_LIST, TYPE_OBJECT]
  icon = Tag
  title = "property"
  multipleChildren = false
  type = TYPE_PROPERTY

  ItemContent = ({ property: { key, value, setValue, setKey }, internalDropzone }) => {

    return <>
      {key !== 'optionList' && <FormGroup>
        <Label>Property Name</Label>
        <Input
          name="key"
          value={key}
          placeholder="Enter the property name from the JSON response"
          onChange={(e) => setKey(e.target.value)}
          required
        />
      </FormGroup>}
      <FormGroup>
        <Label>Value</Label>
        <this.PropertyValue value={value} setValue={setValue} internalDropzone={internalDropzone} />
      </FormGroup>
    </>
  }

  PropertyValue = ({ value, setValue, internalDropzone: { internalDropReference, internalIsOver, internalCanDrop } }) => {
    const { path, id, children } = this.props

    if (children)
      return children

    return <NewKeyValue
      id={id}
      path={path}
      value={value}
      setNewKeyValue={setValue}
      dropReference={internalDropReference}
      isOver={internalIsOver}
      canDrop={internalCanDrop}
    />
  }
}